<div
  class="course-card-wide bg-white max-w-[445px] mx-auto md:max-w-none md:mx-0 rounded-lg overflow-hidden flex flex-col md:flex-row border border-gray-200 shadow-md md:shadow-none md:border-0 mb-8 md:mb-9 last:mb-12 md:pb-4 md:border-b md:border-dotted md:border-gray-200 last:border-b-0"
>
  <!-- Image Container -->
  <div class="relative w-full md:w-[350px] lg:w-[445px] md:flex-shrink-0">
    <div class="absolute top-2 right-2 z-10 flex flex-row-reverse gap-2">
      <span
        *ngIf="isExpiringSoon"
        class="badge bg-red-500 text-white px-3 py-1 rounded text-base font-bold uppercase shadow-md"
      >
        Expiring Soon!
      </span>
      <span
        *ngIf="isEnrolled"
        class="badge bg-green-500 text-white px-3 py-1 rounded text-base font-bold uppercase shadow-md"
      >
        {{ isCompleted ? 'Completed' : 'Enrolled' }}
      </span>
    </div>
    <a [routerLink]="['/courses', course.uuid]">
      <div class="aspect-w-16 aspect-h-9">
        <img
          [src]="course.thumb_path || 'assets/images/no-image.jpg'"
          [alt]="course.title"
          class="w-full h-full object-cover border-b border-gray-200 md:border md:border-gray-100 md:rounded"
        />
      </div>
    </a>

    <!-- Progress Bar -->
    <div *ngIf="isEnrolled" class="progress h-2.5 bg-gray-200 md:mt-2">
      <div
        class="progress-bar bg-green-500 h-full rounded-sm transition-all duration-300 relative overflow-hidden before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent before:animate-progress-slide"
        [style.width.%]="courseProgress"
      ></div>
    </div>
  </div>

  <!-- Course Details -->
  <div class="flex flex-col flex-grow">
    <div class="p-4 md:pt-2 md:px-6 md:pb-4 flex-grow">
      <div class="mb-3">
        <h3 class="text-lg md:text-xl font-semibold leading-tight">
          <a
            [routerLink]="['/courses', course.uuid]"
            class="text-gray-800 hover:text-primary-600 transition-colors"
          >
            {{ course.title }}
          </a>
        </h3>
      </div>

      <div class="space-y-2 md:space-y-1.5">
        <div class="text-sm text-gray-600 flex items-start">
          <svg
            class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <span> <span class="font-medium">Credit Hours:</span> {{ creditHourLabel }} </span>
        </div>

        <div class="text-sm text-gray-600 flex items-start">
          <svg
            class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            ></path>
          </svg>
          <span> <span class="font-medium">Available: </span>{{ availableDateRange || ' ' }} </span>
        </div>

        <div class="text-sm text-gray-600 flex items-start">
          <svg
            class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <span> <span class="font-medium">Credit Offered:</span> {{ creditOfferedText }} </span>
        </div>

        <div *ngIf="isEnrolled" class="text-sm text-gray-600 flex items-start">
          <svg
            class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            ></path>
          </svg>
          <span>
            <span class="font-medium">Progress:</span>
            <span class="text-green-600 font-medium">{{ courseProgress }}%</span>
          </span>
        </div>
      </div>
    </div>

    <div
      class="mt-auto p-4 bg-gray-50 border-t md:border-0 md:bg-transparent md:p-0 md:px-6 md:mt-4"
    >
      <div class="flex space-x-2 md:space-x-3">
        <a
          [routerLink]="['/courses', course.uuid]"
          class="font-semibold btn bg-primary-500 text-white px-3 py-2 rounded hover:bg-primary-600 transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px] md:flex-none md:w-auto"
        >
          Course Details
        </a>

        <a
          *ngIf="isEnrolled && !isCompleted"
          [routerLink]="['/courses', course.uuid]"
          class="font-semibold btn bg-green-500 text-white px-3 py-2 rounded hover:bg-green-600 transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px] md:flex-none md:w-auto"
        >
          Continue
        </a>

        <span
          *ngIf="isEnrolled && isCompleted"
          class="font-semibold btn bg-green-600 text-gray-200 px-3 py-2 rounded text-sm flex-1 text-center whitespace-nowrap min-w-[120px] cursor-not-allowed md:flex-none md:w-auto"
        >
          Completed
        </span>
      </div>
    </div>
  </div>
</div>
